import type { ManifestStatus } from '@/types/manifest';

interface ManifestStatusBadgeProps {
  status: ManifestStatus;
}

const statusStyles: Record<ManifestStatus, string> = {
  Open: 'bg-blue-500/20 text-blue-400 border-blue-500/50',
  InProgress: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/50',
  Complete: 'bg-green-500/20 text-green-400 border-green-500/50',
  Flagged: 'bg-orange-500/20 text-orange-400 border-orange-500/50',
};

const statusLabels: Record<ManifestStatus, string> = {
  Open: 'Open',
  InProgress: 'In Progress',
  Complete: 'Complete',
  Flagged: 'Flagged',
};

export function ManifestStatusBadge({ status }: ManifestStatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${statusStyles[status]}`}
    >
      {statusLabels[status]}
    </span>
  );
}
